import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * The sidebar's two states. `collapsed`: the desktop sidebar shrunk to its
 * icons, remembered per browser. `drawerOpen`: the phone and tablet drawer,
 * opened by the menu button Layout puts beside each page's title - not
 * remembered, so a reload starts it closed.
 */
export const useSidebarStore = create(
  persist(
    (set) => ({
      collapsed: false,
      toggleCollapsed: () => set((state) => ({ collapsed: !state.collapsed })),
      drawerOpen: false,
      setDrawerOpen: (drawerOpen) => set({ drawerOpen }),
    }),
    {
      name: 'nohalfdays-sidebar',
      partialize: (state) => ({ collapsed: state.collapsed }),
    }
  )
);
